<template><!-- svgo-optimised -->
<svg xml:space="preserve" class="icon icon__LOGO icon__brand-logo" fill="#1d1d1b" viewBox="0 0 300.47 90.71" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Calque_1" version="1.1">
<g>
	<path d="M35.11,10.3L8.5,80.4h15.61l5.5-15.6h26.21l5.3,15.6h16.01L50.92,10.3H35.11z M33.64,53.3l9.13-25.73h0.19
		L51.8,53.3H33.64z" class="st0"></path>
	<rect height="15.12" width="15.42" class="st0" y="65.28" x="85.31"></rect>
	<path d="M147.08,10.3h-31.61v70.1h15.41V55.27h16.21c17.47,0,24.25-11.1,24.25-22.49
		C171.33,21.4,164.55,10.3,147.08,10.3z M142.86,43.29h-11.99V22.28h11.99c7.16,0,13.55,1.58,13.55,10.51
		C156.41,41.72,150.02,43.29,142.86,43.29z" class="st0"></path>
	<rect height="15.12" width="15.41" class="st0" y="65.28" x="171.34"></rect>
	<path d="M236.91,69.12c-13.84,0-19.05-11.78-19.05-23.47c0-12.27,5.21-24.05,19.05-24.05c7.66,0,14.34,5.3,15.32,12.27
		h14.92c-1.87-16.2-14.83-25.23-30.24-25.23c-21.7,0-34.46,16.2-34.46,37.01c0,20.23,12.76,36.42,34.46,36.42
		c17.18,0,29.25-11.19,30.83-28.66h-14.92C251.63,62.63,246.34,69.12,236.91,69.12z" class="st0"></path>
	<rect height="15.12" width="15.41" class="st0" y="65.28" x="276.56"></rect>
</g>
</svg>
</template>